import { type } from "os";
import { FunctionComponent, useState } from "react";
import IconButton from "../iconButton/IconButton";
import { FormSelect, SelectOption } from "./FormRow";

interface FormMultiSelectProps {
    id: string,
    title: string,
    titleSelected:string,
    isError: boolean,
    errorMessage: string,
    onAdd: (value: string) => void,
    onRemove: (value: string) => void,
    options: SelectOption[],
    selectedOptions?: string[]
}
 
const FormMultiSelect: FunctionComponent<FormMultiSelectProps> = (props) => {

    let {id , title, titleSelected, isError, errorMessage, onAdd, onRemove, options, selectedOptions = []} = props;


    const add = (value: string) =>{
        onAdd(value);
    }

    const remove = (value: string) => {
        onRemove(value);
    }

    const getOptions = () =>{
        if( !!!options ) return [];
        let result = options.filter((it)=>{
            return selectedOptions.findIndex( so => so == it.value) === -1;
        });

        return result;
    }

    return (
        <>
            {!!options && <>
                            <FormSelect 
                                id={id}
                                title={title}
                                isError={isError}
                                selectedValue={''}
                                errorMessage={errorMessage}
                                onChange={add}
                                options={getOptions()}
                            />
                            

                            <label>{titleSelected}</label>
                            <div className="tags-block additional-block">
                                {selectedOptions && selectedOptions.map((it)=>{
                                    return  <span className="tag" key={`key${it}`}>
                                                <span className="tag-text">{options.find((it2) => { return it2.value == it })?.name}</span>
                                                <IconButton tooltipText="Remove item" type="cross" onClick={()=>{remove(it)}} />
                                            </span>
                                })}
                            </div>
                        </>
            }   
        </>
    );
}
 
export default FormMultiSelect;
